var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.showPopup
        ? _c("send-new-email", { on: { close: _vm.togglePopup } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-form",
            { attrs: { inline: "" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("messages.assignee"), size: "mini" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        value: _vm.filterAssignee,
                        placeholder: _vm.$t("messages.assignee")
                      },
                      on: { change: _vm.handleFilterAssigneeChange }
                    },
                    _vm._l(_vm.participantUsers, function(user) {
                      return _c("el-option", {
                        key: user.person_by_reference.reference,
                        attrs: {
                          label: user.person_by_reference.username,
                          value: user.person_by_reference.reference
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              !_vm.filterRecipient
                ? _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("messages.linked"), size: "mini" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            multiple: "",
                            value: _vm.filterLinked,
                            placeholder: _vm.$t("messages.linked")
                          },
                          on: { change: _vm.handleFilterLinkedChange }
                        },
                        [
                          _c("el-option", {
                            key: "true",
                            attrs: {
                              label: _vm.$t("messages.linked"),
                              value: true
                            }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            key: "false",
                            attrs: {
                              label: _vm.$t("messages.unlinked"),
                              value: false
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("messages.date"), size: "mini" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      align: "right",
                      "unlink-panels": "",
                      "range-separator": "-",
                      "start-placeholder": _vm.$t("startDate"),
                      "end-placeholder": _vm.$t("endDate"),
                      format: "dd-MM-yyyy"
                    },
                    model: {
                      value: _vm.filterDateRange,
                      callback: function($$v) {
                        _vm.filterDateRange = $$v
                      },
                      expression: "filterDateRange"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { size: "mini" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.handleApplyFilter }
                    },
                    [_vm._v(_vm._s(_vm.$t("applyFilters")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { size: "mini" } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        value: _vm.filterSearch,
                        size: "mini",
                        placeholder: "Search"
                      },
                      on: { input: _vm.handleSearchChange },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.handleSearch.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "el-input__icon el-icon-search",
                        attrs: { slot: "prefix" },
                        slot: "prefix"
                      })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { size: "mini" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.handleSearch }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(_vm.$t("search")) + "\n\t\t\t\t"
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { size: "mini" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.handleReset }
                    },
                    [_vm._v(_vm._s(_vm.$t("messages.reset")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-form",
            { attrs: { inline: "" } },
            [
              _c(
                "el-form-item",
                [
                  !!_vm.selectedLegalEntityStore
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            size: "mini",
                            type: "primary",
                            icon: "el-icon-message"
                          },
                          on: { click: _vm.togglePopup }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.$t("messages.new")) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    : _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: _vm.$t("messages.selectSubEntity"),
                            placement: "top"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                disabled: !!!_vm.selectedLegalEntityStore,
                                size: "mini",
                                type: "primary",
                                icon: "el-icon-message"
                              },
                              on: { click: _vm.togglePopup }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("messages.new")) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          )
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _vm.filterRecipient
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            loading: _vm.sendAccountOverviewActionEmailLoading,
                            size: "mini",
                            type: "primary",
                            icon: "el-icon-message"
                          },
                          on: { click: _vm.handleNewMessage }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.$t("messages.sendAccountOverview")) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _vm.filterRecipient
                    ? [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: _vm.messageType !== "IN",
                              type: "info",
                              size: "mini",
                              icon: "el-icon-link"
                            },
                            on: { click: _vm.handleUnlinkMessages }
                          },
                          [_vm._v(_vm._s(_vm.$t("messages.unlink")))]
                        )
                      ]
                    : [
                        _vm.messageType === "IN"
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "info",
                                  size: "mini",
                                  icon: "el-icon-link"
                                },
                                on: { click: _vm.handleLinkMessages }
                              },
                              [_vm._v(_vm._s(_vm.$t("messages.link")))]
                            )
                          : _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t("messages.open_message"),
                                  placement: "top"
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      disabled: true,
                                      type: "info",
                                      size: "mini",
                                      icon: "el-icon-link"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("messages.link")))]
                                )
                              ],
                              1
                            )
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _vm.messageType === "ARCHIVE"
                    ? [
                        _vm.messageType === "IN"
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "info",
                                  size: "mini",
                                  icon: "el-icon-delete"
                                },
                                on: { click: _vm.handleUnarchiveTheLot }
                              },
                              [_vm._v(_vm._s(_vm.$t("messages.unarchive")))]
                            )
                          : _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t("messages.open_message"),
                                  placement: "top"
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      disabled: true,
                                      type: "info",
                                      size: "mini",
                                      icon: "el-icon-delete"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("messages.unarchive")))]
                                )
                              ],
                              1
                            )
                      ]
                    : [
                        _vm.messageType === "IN"
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "info",
                                  size: "mini",
                                  icon: "el-icon-delete"
                                },
                                on: { click: _vm.handleArchiveTheLot }
                              },
                              [_vm._v(_vm._s(_vm.$t("messages.archive")))]
                            )
                          : _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t("messages.open_message"),
                                  placement: "top"
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      disabled: true,
                                      type: "info",
                                      size: "mini",
                                      icon: "el-icon-delete"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("messages.archive")))]
                                )
                              ],
                              1
                            )
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _vm.messageType === "IN" && _vm.selectedLegalEntityStore
                    ? _c(
                        "el-select",
                        {
                          staticStyle: { width: "120px" },
                          attrs: {
                            value: null,
                            placeholder: _vm.$t("messages.assign_to"),
                            size: "mini"
                          },
                          on: { change: _vm.handleAssignTheLot }
                        },
                        _vm._l(_vm.participantUsers, function(user) {
                          return _c("el-option", {
                            key: user.person_by_reference.reference,
                            attrs: {
                              label: user.person_by_reference.username,
                              value: user.person_by_reference.reference
                            }
                          })
                        }),
                        1
                      )
                    : _vm.messageType === "IN" && !_vm.selectedLegalEntityStore
                    ? _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.$t("messages.no_legal_entity"),
                            placement: "top"
                          }
                        },
                        [
                          _c("el-select", {
                            staticStyle: { width: "120px" },
                            attrs: {
                              value: null,
                              placeholder: _vm.$t("messages.assign_to"),
                              disabled: "",
                              size: "mini"
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.$t("messages.open_message"),
                            placement: "top"
                          }
                        },
                        [
                          _c("el-select", {
                            staticStyle: { width: "120px" },
                            attrs: {
                              value: null,
                              placeholder: _vm.$t("messages.assign_to"),
                              disabled: "",
                              size: "mini"
                            }
                          })
                        ],
                        1
                      )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              attrs: {
                data: _vm.messages,
                "default-sort": { prop: "received_at", order: "descending" }
              },
              on: {
                "row-click": _vm.handleRowClick,
                "selection-change": _vm.handleSelectionChange
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: _vm.tableColumnWidths.CHECKBOX
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "",
                  width: _vm.tableColumnWidths.ICON
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.action_by_reference
                          ? _c("interchange-links", {
                              attrs: {
                                links:
                                  scope.row.action_by_reference
                                    .action_interchanges
                              }
                            })
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { width: "48" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm.hasAttachments(scope.row)
                          ? _c("i", { staticClass: "el-icon-paperclip" })
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "from_",
                  label: _vm.$t("messages.from"),
                  width: _vm.tableColumnWidths.TEXT
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("messages.to"),
                  width: _vm.tableColumnWidths.TEXT
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return _vm.messageType == "IN"
                          ? [
                              scope.row.message_by_reference
                                ? [
                                    _vm._v(
                                      _vm._s(scope.row.metadata?.email?.to)
                                    )
                                  ]
                                : _vm._e()
                            ]
                          : undefined
                      }
                    }
                  ],
                  null,
                  true
                )
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "subject", label: _vm.$t("messages.subject") }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("messages.ref"),
                  width: _vm.tableColumnWidths.TEXT,
                  "show-overflow-tooltip": true
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ row }) {
                      return [
                        row.message
                          ? [
                              row.message_by_reference.message_recipients
                                .length > 0
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "hover-underline fc-blue text-ellipsis",
                                      attrs: {
                                        to: {
                                          name: "recipient-detail",
                                          params: {
                                            id:
                                              row.message_by_reference
                                                .message_recipients[0]
                                                .recipient_by_reference
                                                .reference,
                                            participant:
                                              _vm.selectedParticipantStore
                                          }
                                        }
                                      },
                                      nativeOn: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            `${
                                              row.message_by_reference
                                                .message_recipients[0]
                                                .recipient_by_reference.name
                                            } (${
                                              row.message_by_reference
                                                .message_recipients[0]
                                                .recipient_by_reference
                                                .account_id
                                            })`
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          : [
                              _c(
                                "router-link",
                                {
                                  staticClass:
                                    "hover-underline fc-blue text-ellipsis",
                                  attrs: {
                                    to: {
                                      name: "recipient-messages",
                                      params: {
                                        id:
                                          row.action_by_reference
                                            .recipient_by_reference.reference,
                                        participant:
                                          _vm.selectedParticipantStore
                                      }
                                    }
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        `${
                                          row.action_by_reference
                                            .recipient_by_reference.name
                                        } (${
                                          row.action_by_reference
                                            .recipient_by_reference.account_id
                                        })`
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ]
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "received_at",
                  label: _vm.$t("messages.datetime"),
                  width: _vm.tableColumnWidths.DATE_TIME
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.archived_at
                          ? [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm._f("parseTime")(
                                      scope.row.archived_at,
                                      "{d}-{m}-{y} {h}:{i}"
                                    )
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          : [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm._f("parseTime")(
                                      scope.row.received_at,
                                      "{d}-{m}-{y} {h}:{i}"
                                    )
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("messages.assignee"),
                  width: _vm.tableColumnWidths.TEXT
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.action &&
                        scope.row.action_by_reference.assignee
                          ? [
                              _c(
                                "el-tag",
                                {
                                  key: scope.row.action_by_reference.assignee,
                                  staticClass: "mr-5",
                                  attrs: { size: "mini", type: "primary" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.action_by_reference
                                        ?.assignee_by_reference?.username
                                    )
                                  )
                                ]
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.message
                          ? _vm._l(
                              scope.row.message_by_reference.message_assignees,
                              function(message_assignee) {
                                return _c("tooltip-tag", {
                                  key: message_assignee.reference,
                                  attrs: {
                                    content:
                                      message_assignee?.person_by_reference
                                        ?.username,
                                    type: "primary",
                                    size: "mini",
                                    closable: true
                                  },
                                  on: {
                                    close: function($event) {
                                      return _vm.handleUnassign(
                                        scope.row.message,
                                        message_assignee?.person_by_reference
                                          ?.reference
                                      )
                                    }
                                  }
                                })
                              }
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.total != -1
            ? _c(
                "div",
                [
                  _c("pagination", {
                    attrs: {
                      total: _vm.total,
                      page: _vm.page,
                      limit: _vm.limit
                    },
                    on: {
                      "update:page": function($event) {
                        _vm.page = $event
                      },
                      "update:limit": function($event) {
                        _vm.limit = $event
                      },
                      pagination: _vm.getMessages,
                      "pagination-size-change": _vm.handlePageReset
                    }
                  })
                ],
                1
              )
            : _c("div", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: true,
                    expression: "true"
                  }
                ],
                staticStyle: {
                  "min-height": "20px",
                  "margin-top": "17px",
                  "font-size": "17px",
                  float: "left"
                },
                attrs: {
                  "element-loading-spinner": "el-icon-loading",
                  "element-loading-background": "rgba(0, 0, 0, 0)"
                }
              })
        ],
        1
      ),
      _vm._v(" "),
      _c("link-recipient-dialog", { ref: "linkRecipientDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }